class CacheService {
  getIdentityKey(identity: string, api: string) {
    return `${identity}_${api.split('?')[0]}`;
  }

  public cacheValue<T>(identity: string, value: T, prefix: string, api: string): void {
    const storageDataString = sessionStorage.getItem(prefix);

    let data = storageDataString ? JSON.parse(storageDataString) : {};
    const key = this.getIdentityKey(identity, api);

    data = { ...data, [key]: value };

    sessionStorage.setItem(prefix, JSON.stringify(data));
  }

  public getCachedValue<T>(identity: string, prefix: string, api: string): T | null {
    const storageDataString = sessionStorage.getItem(prefix);
    const key = this.getIdentityKey(identity, api);

    if (storageDataString && JSON.parse(storageDataString)[key]) {
      return JSON.parse(storageDataString)[key] as T;
    }

    return null;
  }
}

export const cacheService = new CacheService();
